import { defineComponent as _defineComponent } from 'vue'
import { computed, inject } from 'vue';
import BasicButton from '@/ui-components/BasicButton.vue';
import CompetitionStageHeader from '@/features/sports/components/competition/CompetitionStageHeader.vue';
import EventCard from '@/features/sports/components/global/EventCard.vue';
import FilterBarProviderSeo from '@/components/filter-bar/seo/FilterBarProviderSeo.vue';
import ResetButton from '@/components/buttons/ResetButton.vue';
import Subheading from '@/features/sports/components/ui/Subheading.vue';
import AdUnit from '@/components/AdUnit.vue';
import { ObjectType, SportCompetitionV2 } from '@/@types/graphql-types';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SingleStepContext } from '@/features/sports/helpers/config';
import type { FilterCollection } from '@/stores/filter.store';
import type { SportType } from '@/@types/graphql-types';
import { CompetitionStages } from '@/features/sports/types/competition-stages';
import { useConstantStore, useFilterStore, useLanguageStore } from '@/helpers/composables/useStores';
import { SPORT_PROVIDERS_BY_SHORT_NAME_KEY } from '@/features/sports/types/sports-types';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompetitionFixtures',
  props: {
    isDataLoading: { type: Boolean },
    fixtures: null,
    context: null,
    competitionStages: { default: () => [] }
  },
  emits: ["load-next"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'load-next'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isDataLoading: boolean, fixtures: SportCompetitionV2, context: SingleStepContext, competitionStages: CompetitionStages[] };





const { providersByShortName } = useConstantStore();
const { webLocale } = useLanguageStore();
const { currentFilters } = useFilterStore();
const route = useRoute();

const sportProvidersByShortName = inject(SPORT_PROVIDERS_BY_SHORT_NAME_KEY);

const providers = computed(() => {
	return (
		sportProvidersByShortName?.value
			.map(({ shortName }) => providersByShortName.value[shortName])
			// if BE and FE are out of sync some shortnames might not get matched and be undefined
			.filter(provider => provider != null)
	);
});

const hasNextPage = computed(() => {
	return props.fixtures?.sportEventsV2?.pageInfo?.hasNextPage ?? false;
});

const sportContext = computed(() => {
	const sportType = route.meta?.sport as SportType;
	const sportContext = new SnowplowSportContext(sportType, ObjectType.SportCompetition);
	sportContext.competitionId = props.fixtures.objectId;
	return sportContext;
});

function onLoadNext() {
	emit('load-next');
	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'more_providers_click',
			label: 'fixtures',
		},
		[sportContext.value]
	);
}
function toggleProvider(data: { filterName: keyof FilterCollection; value: any; selectedState: 1 | 0 }) {
	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'filter_toggled',
			label: data.filterName,
			property: data.value ?? 'all',
			value: data.selectedState,
		},
		[sportContext.value]
	);
}

return { __sfc: true,props, emit, providersByShortName, webLocale, currentFilters, route, sportProvidersByShortName, providers, hasNextPage, sportContext, onLoadNext, toggleProvider, BasicButton, CompetitionStageHeader, EventCard, FilterBarProviderSeo, ResetButton, Subheading, AdUnit }
}

})